<template>
  <div>
    <a-card title="个股期权场外交易配置管理" style="margin: 20px">
      <!-- 头部筛选区域 -->
      <div class="selected-box">
        <!-- 部门选择 -->
        <div class="selected-box-item">
          <span class="left-item">机构</span>
          <DepartmentChoose :department-code.sync="searchForm.departmentCode" @change="handleQuery"/>
        </div>
        <!-- 投资代理公司名称 -->
        <div class="selected-box-item">
          <span class="left-item">投资代理公司</span>
          <a-input v-model.trim="searchForm.accountName" placeholder="请输入投资代理公司名称" @pressEnter="handleQuery"/>
        </div>

        <!-- 证券公司名称 -->
        <div class="selected-box-item">
          <span class="left-item">证券公司名称</span>
          <a-input v-model.trim="searchForm.brokerAccountName" placeholder="请输入证券公司名称" @pressEnter="handleQuery"/>
        </div>
        <!-- 审批状态 -->
        <div class="selected-box-item">
          <span class="left-item">审批状态</span>
          <a-select v-model="searchForm.approveStatus" placeholder="请选择审批状态" allow-clear style="width: 200px" @change="handleQuery">
            <a-select-option value="">全部</a-select-option>
            <a-select-option v-for="(type, value) in accountDict.approveStatusMap" :key="value" :value="value">
              <a-tag v-if="type.show" :color="type.color">{{ type.label }}</a-tag>
            </a-select-option>
          </a-select>
        </div>
        <div class="selected-box-item" style="display: block">
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button style="margin-left: 20px" @click="handleReset">重置</a-button>
        </div>
      </div>

      <!-- 表格区域 -->
      <div class="table-box">
        <div class="table-box-handle">
          <a-button type="primary" @click="handleAdd">
            <a-icon type="plus"/>
            新增配置
          </a-button>
        </div>
        <div class="table-main">
          <a-table size="small" :columns="columns" :data-source="tableData" :pagination="false" row-key="id" :loading="loading">
            <template slot="action" slot-scope="text, record">
              <a-button-group>
                <a-button type="link" @click="handleDetail(record)" size="small">
                  <a-icon type="eye"/>
                  详情
                </a-button>
                <!-- 仅审批中状态可以编辑 -->
                <!--                <a-button v-if="record.approveStatus === '00'" type="link" @click="handleEdit(record)" size="small">-->
                <!--                  <a-icon type="edit"/>-->
                <!--                  编辑-->
                <!--                </a-button>-->
                <!-- 仅审批中状态可以审批 -->
                <a-button v-if="record.approveStatus === '00'" type="link" @click="showApproveModal(record)" size="small" style="color: #52c41a;">
                  <a-icon type="check-circle"/>
                  审批
                </a-button>
                <!-- 买入/赎回操作按钮 -->
                <a-button v-if="record.approveStatus === '01' && $authority('buySettlement')" type="link" @click="showBuyModal(record)" size="small" style="color: #1890ff;">
                  <a-icon type="shopping-cart"/>
                  买入
                </a-button>
                <a-button v-if="record.approveStatus === '01' && $authority('sellSettlement')" type="link" @click="showSellModal(record)" size="small" style="color: #faad14;">
                  <a-icon type="export"/>
                  赎回
                </a-button>
                <!-- 仅审批中或驳回状态可以删除 v-if="['00', '02'].includes(record.approveStatus)"  -->
                <a-button type="link" @click="handleDelete(record)" size="small" style="color: #ff4d4f">
                  <a-icon type="delete"/>
                  删除
                </a-button>
                <a-button type="link" @click="showTradeRecordModal(record)" size="small" style="color: #722ed1;">
                  <a-icon type="file-text"/>
                  交易记录
                </a-button>
              </a-button-group>
            </template>
          </a-table>
        </div>
      </div>

      <!-- 分页 -->
      <lcfs-pagination
          :page-no.sync="pagination.pageNo"
          :page-size.sync="pagination.pageSize"
          :total="total"
          :fn="fetchData"
      />
    </a-card>

    <!-- 新增/编辑弹窗 -->
    <a-modal :title="modalTitle" :visible="modalVisible" :width="800" :maskClosable="false" :confirm-loading="modalLoading" @ok="handleModalOk"
             @cancel="handleModalCancel">
      <a-form-model ref="formRef" :model="formData" :rules="formRules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">


        <a-form-model-item label="投资代理公司A2" prop="accountNoA2">
          <WalletChooseDialog v-model="formData.accountNameA2" placeholder="请选择投资代理公司A2" account-class="6" @chooseDone="onInvestmentAgentA2Chosen"/>
          <WalletInfo
              v-if="formData.accountNoA2"
              :account-no="formData.accountNoA2"
              :account-name="formData.accountNameA2"
              show-account-name
              :show-account-no="true"
              style="margin-top: 8px"/>
        </a-form-model-item>


        <a-form-model-item label="证券公司账号" prop="brokerAccountNo">
          <a-input v-model.trim="formData.brokerAccountNo" placeholder="请输入证券公司账号 6222027915731192533"/>
        </a-form-model-item>
        <a-form-model-item label="证券公司账户" prop="brokerAccountName">
          <a-input v-model.trim="formData.brokerAccountName" placeholder="请输入证券公司账户 张飞"/>
        </a-form-model-item>
        <a-form-model-item label="证券公司账户行号" prop="brokerBankNo">
          <a-input v-model.trim="formData.brokerBankNo" placeholder="请输入证券公司账户行号 102100099996"/>
        </a-form-model-item>
        <a-form-model-item label="证券公司账户行名" prop="brokerBankName">
          <a-input v-model.trim="formData.brokerBankName" placeholder="请输入证券公司账户行名 中国工商银行"/>
        </a-form-model-item>
        <a-form-model-item label="手续费规则" prop="feeRuleNo">
          <a-select v-model="formData.feeRuleNo" placeholder="请选择手续费规则" allow-clear style="width: 100%" @change="handleFeeRuleChange">
            <a-select-option v-for="item in feeRuleList" :key="item.feeNo" :value="item.feeNo">
              {{ item.feeName }}
            </a-select-option>
          </a-select>
          <div v-if="formData.feeRuleName" style="color: #666; margin-top: 4px; font-size: 12px">
            规则名称：{{ formData.feeRuleName }}
          </div>
        </a-form-model-item>
        <a-form-model-item label="手续费收款账户配置" prop="oppFeeAccountNo">
          <WalletChooseDialog v-model="formData.oppFeeAccountName" placeholder="请选择手续费收款账户" @chooseDone="onOppFeeAccountChosen"/>
          <WalletInfo
              v-if="formData.oppFeeAccountNo"
              :account-no="formData.oppFeeAccountNo"
              :account-name="formData.oppFeeAccountName"
              show-account-name
              :show-account-no="true"
              style="margin-top: 8px"/>
        </a-form-model-item>
        <a-form-model-item label="买进备注" prop="buyInNote">
          <a-textarea v-model.trim="formData.buyInNote" placeholder="请输入买进备注" :rows="3"/>
        </a-form-model-item>
        <a-form-model-item label="赎回备注" prop="sellOutNote">
          <a-textarea v-model.trim="formData.sellOutNote" placeholder="请输入赎回备注" :rows="3"/>
        </a-form-model-item>
        <a-form-model-item label="服务费备注" prop="feeNote">
          <a-textarea v-model.trim="formData.feeNote" placeholder="请输入服务费备注" :rows="3"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 详情弹窗 -->
    <a-modal :title="detailModalTitle" :visible="detailModalVisible" @cancel="detailModalVisible = false" :footer="null" :width="800">
      <a-descriptions :column="1" bordered>
        <a-descriptions-item label="机构">
          <DeptInfo :dept-id="detailData.departmentId"/>
        </a-descriptions-item>
        <a-descriptions-item label="投资代理公司">
          <WalletInfo
              v-if="detailData.accountNo"
              :account-no="detailData.accountNo"
              :account-name="detailData.accountName"
              show-account-name
              :show-account-no="true"/>
        </a-descriptions-item>
        <a-descriptions-item label="投资代理公司A2">
          <WalletInfo
              v-if="detailData.accountNoA2"
              :account-no="detailData.accountNoA2"
              :account-name="detailData.accountNameA2"
              show-account-name
              :show-account-no="true"/>
        </a-descriptions-item>
        <a-descriptions-item label="证券公司名称">
          <WalletInfo
              v-if="detailData.brokerAccountNo"
              :account-no="detailData.brokerAccountNo"
              :account-name="detailData.brokerAccountName"
              show-account-name
              :show-account-no="true"/>
        </a-descriptions-item>
        <a-descriptions-item label="证券公司账户行号">
          {{ detailData.brokerBankNo || '未填写' }}
        </a-descriptions-item>
        <a-descriptions-item label="证券公司账户行名">
          {{ detailData.brokerBankName || '未填写' }}
        </a-descriptions-item>
        <a-descriptions-item label="手续费配置">
          {{ detailData.feeRuleNo || '未填写' }}
        </a-descriptions-item>
        <a-descriptions-item label="手续费收款账户配置">
          <WalletInfo
              v-if="detailData.oppFeeAccountNo"
              :account-no="detailData.oppFeeAccountNo"
              :account-name="detailData.oppFeeAccountName"
              show-account-name
              :show-account-no="true"/>
        </a-descriptions-item>
        <a-descriptions-item label="买进备注">
          {{ detailData.buyInNote || '无' }}
        </a-descriptions-item>
        <a-descriptions-item label="赎回备注">
          {{ detailData.sellOutNote || '无' }}
        </a-descriptions-item>
        <a-descriptions-item label="服务费备注">
          {{ detailData.feeNote || '无' }}
        </a-descriptions-item>
        <a-descriptions-item label="审批状态">
          <a-badge
              :color="getApproveStatus(detailData.approveStatus).color"
              :text="getApproveStatus(detailData.approveStatus).label"
          />
        </a-descriptions-item>
        <a-descriptions-item v-if="detailData.approveUser" label="审批人">
          {{ detailData.approveUser }}
        </a-descriptions-item>
        <a-descriptions-item v-if="detailData.approveTime" label="审批时间">
          {{ formatDateTime(detailData.approveTime) }}
        </a-descriptions-item>
        <a-descriptions-item v-if="detailData.approveRemark" label="审批意见">
          {{ detailData.approveRemark }}
        </a-descriptions-item>
        <a-descriptions-item label="创建人">
          {{ detailData.creater || '未知' }}
        </a-descriptions-item>
        <a-descriptions-item label="创建时间">
          {{ formatDateTime(detailData.createTime) }}
        </a-descriptions-item>
        <a-descriptions-item label="更新人">
          {{ detailData.updater || '未知' }}
        </a-descriptions-item>
        <a-descriptions-item label="更新时间">
          {{ formatDateTime(detailData.updateTime) }}
        </a-descriptions-item>
      </a-descriptions>
    </a-modal>

    <!-- 审批弹窗 -->
    <a-modal :title="`审批操作 - ${approveModal.currentRecord?.accountName || ''}`" :visible="approveModal.visible" @ok="handleApproveSubmit"
             @cancel="approveModal.visible = false" :confirm-loading="approveModal.loading" :width="500">
      <a-form-model ref="approveFormRef" :model="approveFormData" :rules="approveFormRules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" :colon="false"
                    label-align="left">
        <a-form-model-item label="投资代理公司">
          <WalletInfo
              v-if="approveModal.currentRecord?.accountNo"
              :account-no="approveModal.currentRecord?.accountNo"
              :account-name="approveModal.currentRecord?.accountName"
              show-account-name
              :show-account-no="true"/>
        </a-form-model-item>
        <a-form-model-item label="证券公司名称">
          <WalletInfo
              v-if="approveModal.currentRecord?.brokerAccountNo"
              :account-no="approveModal.currentRecord?.brokerAccountNo"
              :account-name="approveModal.currentRecord?.brokerAccountName"
              show-account-name
              :show-account-no="true"/>
        </a-form-model-item>

        <a-form-model-item label="审批结果" prop="approveStatus">
          <a-radio-group v-model="approveFormData.approveStatus">
            <a-radio value="01">通过</a-radio>
            <a-radio value="02">驳回</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="审批意见" prop="approveRemark" :required="approveFormData.approveStatus === '02'">
          <a-textarea v-model.trim="approveFormData.approveRemark" :placeholder="approveFormData.approveStatus === '02' ? '请输入驳回原因' : '请输入审批意见'"
                      :rows="4" :max-length="500"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 买入操作弹窗 -->
    <a-modal :title="`买入操作 - ${buyModal.currentRecord?.accountName || ''}`" :visible="buyModal.visible" @ok="handleBuySubmit"
             @cancel="buyModal.visible = false" :confirm-loading="buyModal.loading" :width="500">
      <a-form-model ref="buyFormRef" :model="buyFormData" :rules="buyFormRules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" :colon="false"
                    label-align="left">
        <a-form-model-item label="投资代理公司">
          <WalletInfo
              v-if="buyModal.currentRecord?.accountNoA2"
              :account-no="buyModal.currentRecord?.accountNoA2"
              :account-name="buyModal.currentRecord?.accountName"
              show-account-name
              :show-account-no="true"/>
        </a-form-model-item>
        <a-form-model-item label="证券公司名称">
          <WalletInfo
              v-if="buyModal.currentRecord?.brokerAccountNo"
              :account-no="buyModal.currentRecord?.brokerAccountNo"
              :account-name="buyModal.currentRecord?.brokerAccountName"
              show-account-name
              :show-account-no="true"/>
        </a-form-model-item>
        <a-form-model-item label="结算日期" prop="settleDate">
          <a-date-picker v-model="buyFormData.settleDate" placeholder="请选择结算日期"  format="YYYY-MM-DD" value-format="YYYY-MM-DD"  :disabled-date="disabledFutureDate"/>
        </a-form-model-item>
<!--        <a-form-model-item label="买入金额" prop="buyAmount">-->
<!--          <a-input-number v-model="buyFormData.buyAmount" placeholder="请输入买入金额" style="width: 100%" :precision="2"/>-->
<!--        </a-form-model-item>-->
<!--        <a-form-model-item label="备注" prop="remark">-->
<!--          <a-textarea v-model.trim="buyFormData.remark" :rows="3" :max-length="500" placeholder="请输入备注信息"/>-->
<!--        </a-form-model-item>-->
      </a-form-model>
    </a-modal>

    <!-- 赎回操作弹窗 -->
    <a-modal :title="`赎回操作 - ${sellModal.currentRecord?.accountName || ''}`" :visible="sellModal.visible" @ok="handleSellSubmit"
             @cancel="sellModal.visible = false" :confirm-loading="sellModal.loading" :width="500">
      <a-form-model ref="sellFormRef" :model="sellFormData" :rules="sellFormRules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" :colon="false"
                    label-align="left">
        <a-form-model-item label="投资代理公司">
          <WalletInfo
              v-if="sellModal.currentRecord?.accountNoA2"
              :account-no="sellModal.currentRecord?.accountNoA2"
              :account-name="sellModal.currentRecord?.accountName"
              show-account-name
              :show-account-no="true"/>
        </a-form-model-item>
        <a-form-model-item label="证券公司名称">
          <WalletInfo
              v-if="sellModal.currentRecord?.brokerAccountNo"
              :account-no="sellModal.currentRecord?.brokerAccountNo"
              :account-name="sellModal.currentRecord?.brokerAccountName"
              show-account-name
              :show-account-no="true"/>
        </a-form-model-item>
        <a-form-model-item label="结算日期" prop="settleDate">
          <a-date-picker v-model="sellFormData.settleDate" placeholder="请选择结算日期" style="width: 100%" format="YYYY-MM-DD" value-format="YYYY-MM-DD" :disabled-date="disabledFutureDate"/>
        </a-form-model-item>
<!--        <a-form-model-item label="赎回金额" prop="sellAmount">-->
<!--          <a-input-number v-model="sellFormData.sellAmount" placeholder="请输入赎回金额" style="width: 100%" :precision="2"/>-->
<!--        </a-form-model-item>-->
<!--        <a-form-model-item label="备注" prop="remark">-->
<!--          <a-textarea v-model.trim="sellFormData.remark" :rows="3" :max-length="500" placeholder="请输入备注信息"/>-->
<!--        </a-form-model-item>-->
      </a-form-model>
    </a-modal>

    <!-- 删除确认弹窗 -->
    <a-modal
        title="确认删除"
        :visible="deleteModalVisible"
        @ok="handleDeleteConfirm"
        @cancel="deleteModalVisible = false"
    >
      <p>确定要删除这条个股期权场外交易配置吗？</p>
      <p style="color: #ff4d4f; margin-top: 8px">删除后将无法恢复，请谨慎操作！</p>
    </a-modal>

    <!-- 交易记录弹窗 -->
    <a-modal :title="`交易记录 - ${tradeRecordModal.currentRecord?.accountName || ''}`" :visible="tradeRecordModal.visible" :width="1200"
             @cancel="tradeRecordModal.visible = false" :footer="null" :maskClosable="false">
      <div class="trade-record-search">
        <span>业务类型：</span>
        <a-select v-model="tradeRecordSearchForm.bizType" placeholder="全部" allow-clear style="width: 120px" @change="handleTradeRecordSearch">
          <a-select-option value="BUY">买入</a-select-option>
          <a-select-option value="SELL">卖出</a-select-option>
        </a-select>
        <span style="margin-left: 16px">状态：</span>
        <a-select v-model="tradeRecordSearchForm.status" placeholder="全部" allow-clear style="width: 120px" @change="handleTradeRecordSearch">
          <a-select-option v-for="(item, key) in tradeRecordStatusMap" :key="key" :value="key">{{ item.label }}</a-select-option>
        </a-select>
        <span style="margin-left: 16px">交易日期：</span>
        <a-range-picker v-model="tradeRecordSearchForm.dateRange" format="YYYY-MM-DD" value-format="YYYY-MM-DD" @change="handleTradeRecordSearch"/>
      </div>
      <a-table size="small" :columns="tradeRecordColumns" :data-source="tradeRecordTableData" :pagination="false" row-key="id" :loading="tradeRecordLoading"  :scroll="{ y: 300 ,width: 1000} " style="margin-top: 16px">
        <template slot="bizType" slot-scope="text">
          <a-tag :color="text === 'BUY' ? 'blue' : 'orange'">{{ text === 'BUY' ? '买入' : '卖出' }}</a-tag>
        </template>
        <template slot="status" slot-scope="text">
          <a-tag :color="tradeRecordStatusMap[text]?.color || '#C7C7CC'">{{ tradeRecordStatusMap[text]?.label || '未知' }}</a-tag>
        </template>
        <template slot="totalAmount" slot-scope="text">
          <Balance v-if="text !== null && text !== undefined" :amount="text" prefix="¥"/>
          <span v-else>--</span>
        </template>
        <template slot="currentAmount" slot-scope="text">
          <Balance v-if="text !== null && text !== undefined" :amount="text" prefix="¥"/>
          <span v-else>--</span>
        </template>
        <template slot="processedAmount" slot-scope="text">
          <Balance v-if="text !== null && text !== undefined" :amount="text" prefix="¥"/>
          <span v-else>--</span>
        </template>
        <template slot="feeAmount" slot-scope="text">
          <Balance v-if="text !== null && text !== undefined" :amount="text" prefix="¥"/>
          <span v-else>--</span>
        </template>
        <template slot="transferAmount" slot-scope="text">
          <Balance v-if="text !== null && text !== undefined" :amount="text" prefix="¥"/>
          <span v-else>--</span>
        </template>
        <template slot="tradeDate" slot-scope="text">
          {{ text || '--' }}
        </template>
        <template slot="createTime" slot-scope="text">
          {{ text ? formatDateTime(text) : '--' }}
        </template>
        <template slot="action" slot-scope="text, record">
          <a-button type="link" size="small" @click="showTradeRecordDetail(record)">
            <a-icon type="eye"/>
            详情
          </a-button>
        </template>
      </a-table>
      <lcfs-pagination
          :page-no.sync="tradeRecordPagination.pageNo"
          :page-size.sync="tradeRecordPagination.pageSize"
          :total="tradeRecordTotal"
          :fn="fetchTradeRecordData"
          style="margin-top: 16px"
      />
    </a-modal>

    <!-- 交易记录详情弹窗 -->
    <a-modal title="交易记录详情" :visible="tradeRecordDetailVisible" @cancel="tradeRecordDetailVisible = false" :footer="null" :width="700">
      <a-descriptions :column="2" bordered>
        <a-descriptions-item label="配置ID">{{ tradeRecordDetailData.configId || '--' }}</a-descriptions-item>
        <a-descriptions-item label="交易日期">{{ tradeRecordDetailData.tradeDate || '--' }}</a-descriptions-item>
        <a-descriptions-item label="业务类型">
          <a-tag :color="tradeRecordDetailData.bizType === 'BUY' ? 'blue' : 'orange'">
            {{ tradeRecordDetailData.bizType === 'BUY' ? '买入' : '卖出' }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="状态">
          <a-tag :color="tradeRecordStatusMap[tradeRecordDetailData.status]?.color || '#C7C7CC'">
            {{ tradeRecordStatusMap[tradeRecordDetailData.status]?.label || '未知' }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="交易总金额">
          <Balance v-if="tradeRecordDetailData.totalAmount !== null && tradeRecordDetailData.totalAmount !== undefined" :amount="tradeRecordDetailData.totalAmount" prefix="¥"/>
          <span v-else>--</span>
        </a-descriptions-item>
        <a-descriptions-item label="本次处理金额">
          <Balance v-if="tradeRecordDetailData.currentAmount !== null && tradeRecordDetailData.currentAmount !== undefined" :amount="tradeRecordDetailData.currentAmount" prefix="¥"/>
          <span v-else>--</span>
        </a-descriptions-item>
        <a-descriptions-item label="累计已处理金额">
          <Balance v-if="tradeRecordDetailData.processedAmount !== null && tradeRecordDetailData.processedAmount !== undefined" :amount="tradeRecordDetailData.processedAmount" prefix="¥"/>
          <span v-else>--</span>
        </a-descriptions-item>
        <a-descriptions-item label="手续费金额">
          <Balance v-if="tradeRecordDetailData.feeAmount !== null && tradeRecordDetailData.feeAmount !== undefined" :amount="tradeRecordDetailData.feeAmount" prefix="¥"/>
          <span v-else>--</span>
        </a-descriptions-item>
        <a-descriptions-item label="实际转账金额">
          <Balance v-if="tradeRecordDetailData.transferAmount !== null && tradeRecordDetailData.transferAmount !== undefined" :amount="tradeRecordDetailData.transferAmount" prefix="¥"/>
          <span v-else>--</span>
        </a-descriptions-item>
        <a-descriptions-item label="支付流水号">{{ tradeRecordDetailData.serialNo || '--' }}</a-descriptions-item>
        <a-descriptions-item label="错误信息" :span="2">
          <span style="color: #ff4d4f">{{ tradeRecordDetailData.errorMsg || '无' }}</span>
        </a-descriptions-item>
        <a-descriptions-item label="重试次数">{{ tradeRecordDetailData.retryCount || 0 }}</a-descriptions-item>
        <a-descriptions-item label="创建时间">{{ tradeRecordDetailData.createTime ? formatDateTime(tradeRecordDetailData.createTime) : '--' }}</a-descriptions-item>
        <a-descriptions-item label="更新人">{{ tradeRecordDetailData.updater || '--' }}</a-descriptions-item>
        <a-descriptions-item label="更新时间">{{ tradeRecordDetailData.updateTime ? formatDateTime(tradeRecordDetailData.updateTime) : '--' }}</a-descriptions-item>
      </a-descriptions>
    </a-modal>
  </div>
</template>

<script>
import DeptInfo from "@/view/components/DeptInfo.vue";
import DepartmentChoose from "@/view/components/DepartmentChoose.vue";
import WalletChooseDialog from "@/view/components/ChooseDialog/WalletChooseDialog.vue";
import WalletInfo from "@/view/components/WalletInfo.vue";
import LcfsPagination from "@/view/components/LcfsPagination.vue";
import Balance from "@/view/components/Balance.vue";
import {accountDict} from "@/utils/bizDict/accountDict";
import moment from "moment";

export default {
  name: 'optionOtcTradeCfg',
  components: {
    DepartmentChoose,
    WalletChooseDialog,
    WalletInfo,
    DeptInfo,
    LcfsPagination,
    Balance
  },
  data() {
    return {
      // 查询表单
      searchForm: {
        departmentCode: '',
        accountName: '',
        accountNo: '',
        brokerAccountName: '',
        approveStatus: ''
      },

      // 表格数据
      tableData: [],
      loading: false,

      // 分页
      pagination: {
        pageNo: 1,
        pageSize: 10
      },
      total: 0,

      // 表格列配置
      columns: [
        {
          title: '序号',
          align: 'center',
          width: 60,
          customRender: (text, record, index) => {
            return (this.pagination.pageNo - 1) * this.pagination.pageSize + index + 1;
          }
        },
        {
          title: '机构',
          dataIndex: 'departmentId',
          align: 'center',
          ellipsis: true,
          width: 120,
          customRender: (text) => {
            return <DeptInfo dept-id={text}/>
          },
        },
        {
          title: '投资代理公司',
          align: 'center',
          width: 200,
          customRender: (text, record) => {
            return (<WalletInfo accountNo={record.accountNo} accountName={record.accountName} showAccountName={true}/>);
          }
        },
        {
          title: '投资代理公司A2',
          align: 'center',
          width: 200,
          customRender: (text, record) => {
            return (<WalletInfo accountNo={record.accountNoA2} accountName={record.accountName} showAccountName={true}/>);
          }
        },
        {
          title: '证券公司名称',
          align: 'center',
          width: 200,
          customRender: (text, record) => {
            return (<WalletInfo accountNo={record.brokerAccountNo} accountName={record.brokerAccountName} showAccountName={true} isWallet={false}/>);
          }
        },
        {
          title: '手续费收款账户配置',
          align: 'center',
          width: 200,
          customRender: (text, record) => {
            if (!record.oppFeeAccountNo) {
              return '--';
            }
            return (<WalletInfo accountNo={record.oppFeeAccountNo} showAccountName={false}/>);
          }
        },
        {
          title: '手续费配置',
          dataIndex: 'feeRuleNo',
          align: 'center',
          ellipsis: true,
          width: 100
        },
        {
          title: '审批状态',
          dataIndex: 'approveStatus',
          align: 'center',
          width: 80,
          customRender: (text) => {
            return <a-tag color={this.getApproveStatus(text).color}>{this.getApproveStatus(text).label}</a-tag>
          },
        },

        {
          title: '操作',
          align: 'center',
          width: 400,
          fixed: 'right',
          scopedSlots: {customRender: 'action'}
        }
      ],

      // 弹窗相关
      modalVisible: false,
      modalLoading: false,
      modalTitle: '新增个股期权场外交易配置',

      detailModalVisible: false,
      detailModalTitle: '个股期权场外交易配置详情',
      detailData: {},

      approveModal: {
        visible: false,
        loading: false,
        currentRecord: null
      },
      approveFormData: {
        approveStatus: "01",
        approveRemark: ""
      },
      approveFormRules: {
        approveStatus: [
          {required: true, message: '请选择审批结果', trigger: 'change'}
        ],
        approveRemark: [
          {required: true, message: '请输入审批意见', trigger: 'blur'},
          {max: 500, message: '长度不能超过500个字符', trigger: 'blur'}
        ]
      },

      buyModal: {
        visible: false,
        loading: false,
        currentRecord: null
      },
      buyFormData: {
        settleDate: null,
        buyAmount: null,
        remark: ""
      },
      buyFormRules: {
        settleDate: [
          {required: true, message: '请选择结算日期', trigger: 'change'}
        ],
        // buyAmount: [
        //   {required: true, message: '请输入买入金额', trigger: 'blur'},
        //   {type: 'number', min: 0, message: '买入金额不能小于0', trigger: 'blur'}
        // ]
      },

      sellModal: {
        visible: false,
        loading: false,
        currentRecord: null
      },
      sellFormData: {
        settleDate: null,
        sellAmount: null,
        remark: ""
      },
      sellFormRules: {
        settleDate: [
          {required: true, message: '请选择结算日期', trigger: 'change'}
        ],
        // sellAmount: [
        //   {required: true, message: '请输入赎回金额', trigger: 'blur'},
        //   {type: 'number', min: 0, message: '赎回金额不能小于0', trigger: 'blur'}
        // ]
      },

      deleteModalVisible: false,

      // 交易记录弹窗相关
      tradeRecordModal: {
        visible: false,
        loading: false,
        currentRecord: null
      },
      tradeRecordSearchForm: {
        bizType: undefined,
        status: undefined,
        dateRange: []
      },
      tradeRecordPagination: {
        pageNo: 1,
        pageSize: 10
      },
      tradeRecordTotal: 0,
      tradeRecordTableData: [],
      tradeRecordLoading: false,
      tradeRecordColumns: [
        {title: '序号', align: 'center', width: 60, customRender: (text, record, index) => (this.tradeRecordPagination.pageNo - 1) * this.tradeRecordPagination.pageSize + index + 1},
        {title: '交易日期', dataIndex: 'tradeDate', align: 'center', width: 120, scopedSlots: {customRender: 'tradeDate'}},
        {title: '流水号', dataIndex: 'serialNo', align: 'center', width: 200, ellipsis: true},
        {title: '业务类型', dataIndex: 'bizType', align: 'center', width: 80, scopedSlots: {customRender: 'bizType'}},
        {title: '状态', dataIndex: 'status', align: 'center', width: 100, scopedSlots: {customRender: 'status'}},
        {title: '本次处理金额', dataIndex: 'currentAmount', align: 'center', width: 140, scopedSlots: {customRender: 'currentAmount'}},
        {title: '累计已处理金额', dataIndex: 'processedAmount', align: 'center', width: 140, scopedSlots: {customRender: 'processedAmount'}},
        {title: '手续费金额', dataIndex: 'feeAmount', align: 'center', width: 120, scopedSlots: {customRender: 'feeAmount'}},
        {title: '实际转账金额', dataIndex: 'transferAmount', align: 'center', width: 140, scopedSlots: {customRender: 'transferAmount'}},

      ],
      tradeRecordStatusMap: {
        '00': {color: 'blue', label: '处理中'},
        '01': {color: 'green', label: '成功'},
        '02': {color: 'red', label: '失败'},
        '03': {color: 'orange', label: '部分成功'}
      },
      tradeRecordDetailVisible: false,
      tradeRecordDetailData: {},

      // 表单数据
      formData: {
        id: null,
        departmentCode: '',
        accountName: '',
        accountNo: '',
        accountNameA2: '',
        accountNoA2: '',
        brokerAccountName: '',
        brokerAccountNo: '',
        brokerBankNo: '',
        brokerBankName: '',
        feeRuleNo: '',
        feeRuleName: '',
        oppFeeAccountName: '',
        oppFeeAccountNo: '',
        buyInNote: '',
        sellOutNote: '',
        feeNote: '',
        approveStatus: ''
      },

      // 表单验证规则
      formRules: {
        accountNo: [
          {required: true, message: '请选择投资代理公司', trigger: 'blur'}
        ],
        accountNoA2: [
          {required: true, message: '请选择投资代理公司A2', trigger: 'blur'}
        ],
        brokerAccountNo: [
          {required: true, message: '请输入证券公司账号', trigger: 'blur'}
        ],
        brokerAccountName: [
          {required: true, message: '请输入证券公司账户', trigger: 'blur'}
        ],
        brokerBankNo: [
          {required: true, message: '请输入证券公司大额行号', trigger: 'blur'}
        ],
        brokerBankName: [
          {required: true, message: '请输入证券公司开户行名称', trigger: 'blur'}
        ],

      },
      // 手续费规则列表
      feeRuleList: [],
      // 当前操作的数据
      currentRecord: null
    };
  },
  created() {
    this.fetchData();
    this.loadFeeRules();
  },
  computed: {
    accountDict() {
      return accountDict;
    }
  },
  watch: {},
  methods: {
    // 加载手续费规则
    async loadFeeRules() {
      try {
        const res = await this.api.getCommisionFeeRuleApi({});
        if (res.code === 200) {
          this.feeRuleList = res.data.filter(item => item.feeType !== '4');
        }
      } catch (error) {
        console.error('加载手续费规则失败:', error);
      }
    },
    // 状态配置方法
    getApproveStatus(status) {
      return accountDict.approveStatusMap[status] || accountDict.approveStatusMap.default;
    },

    // 获取表格数据
    async fetchData() {
      this.loading = true;
      try {
        const params = {
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,
          ...this.searchForm
        };

        const res = await this.api.optionOtcTradeCfg.page(params);
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.info);
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },

    // 查询
    handleQuery() {
      this.pagination.pageNo = 1;
      this.fetchData();
    },

    // 重置
    handleReset() {
      this.searchForm = {
        departmentCode: '',
        accountName: '',
        accountNo: '',
        brokerAccountName: '',
        approveStatus: ''
      };
      this.pagination.pageNo = 1;
      this.fetchData();
    },

    // 新增
    handleAdd() {
      this.modalTitle = '新增个股期权场外交易配置';
      this.formData = {
        id: null,
        departmentCode: '',
        accountName: '',
        accountNo: '',
        accountNameA2: '',
        accountNoA2: '',
        brokerAccountName: '',
        brokerAccountNo: '',
        brokerBankNo: '',
        brokerBankName: '',
        feeRuleNo: '',
        oppFeeAccountName: '',
        oppFeeAccountNo: '',
        buyInNote: '',
        sellOutNote: '',
        feeNote: '',
        approveStatus: ''
      };

      this.modalVisible = true;
    },


    // 选择投资代理公司A2
    onInvestmentAgentA2Chosen(wallet) {
      this.formData.accountNoA2 = wallet.accountNo;
      this.formData.accountNo = wallet.majorAccountNo;
      this.formData.accountNameA2 = wallet.accountName;
    },

    // 选择证券公司
    onBrokerChosen(wallet) {
      this.formData.brokerAccountNo = wallet.accountNo;
      this.formData.brokerAccountName = wallet.accountName;
    },
    // 手续费规则变更
    handleFeeRuleChange(value) {
      const rule = this.feeRuleList.find(item => item.feeNo === value);
      this.formData.feeRuleName = rule ? rule.feeName : '';
    },

    // 选择手续费收款账户
    onOppFeeAccountChosen(wallet) {
      this.formData.oppFeeAccountNo = wallet.accountNo;
      this.formData.oppFeeAccountName = wallet.accountName;
    },

    // 编辑
    async handleEdit(record) {
      // 只有审批中状态可以编辑
      if (record.approveStatus !== '00') {
        this.$message.warning('只有审批中状态的记录可以编辑');
        return;
      }

      this.modalTitle = '编辑个股期权场外交易配置';
      this.currentRecord = record;

      try {
        const res = await this.api.optionOtcTradeCfg.detail({id: record.id});
        if (res.code === 200) {
          this.formData = {
            id: res.data.id,
            departmentCode: res.data.departmentCode,
            accountName: res.data.accountName,
            accountNo: res.data.accountNo,
            accountNameA2: res.data.accountNameA2,
            accountNoA2: res.data.accountNoA2,
            brokerAccountName: res.data.brokerAccountName,
            brokerAccountNo: res.data.brokerAccountNo,
            brokerBankNo: res.data.brokerBankNo,
            brokerBankName: res.data.brokerBankName,
            feeRuleNo: res.data.feeRuleNo,
            oppFeeAccountName: res.data.oppFeeAccountName,
            oppFeeAccountNo: res.data.oppFeeAccountNo,
            buyInNote: res.data.buyInNote,
            sellOutNote: res.data.sellOutNote,
            feeNote: res.data.feeNote,
            approveStatus: res.data.approveStatus
          };

          this.modalVisible = true;
        } else {
          this.$message.error(res.info);
        }
      } catch (error) {
        console.error('获取详情失败:', error);
        this.$message.error('获取详情失败');
      }
    },

    // 详情
    async handleDetail(record) {
      this.detailModalTitle = '个股期权场外交易配置详情';
      try {
        const res = await this.api.optionOtcTradeCfg.detail({id: record.id});
        if (res.code === 200) {
          this.detailData = res.data;
          this.detailModalVisible = true;
        } else {
          this.$message.error(res.info);
        }
      } catch (error) {
        console.error('获取详情失败:', error);
        this.$message.error('获取详情失败');
      }
    },

    // 买入操作
    showBuyModal(record) {
      this.buyModal.currentRecord = record;
      this.buyModal.visible = true;

      this.$nextTick(() => {
        this.buyFormData = {
          settleDate: null,
          buyAmount: null,
          remark: ""
        };
        this.$refs.buyFormRef && this.$refs.buyFormRef.resetFields();
      });
    },

    // 提交买入操作
    async handleBuySubmit() {
      this.$refs.buyFormRef.validate(async (valid) => {
        if (!valid) {
          this.$message.error('请填写完整信息');
          return;
        }

        this.buyModal.loading = true;
        try {
          const params = {
            id: this.buyModal.currentRecord.id,
            settleDate: this.buyFormData.settleDate,
            buyAmount: this.buyFormData.buyAmount,
            remark: this.buyFormData.remark
          };

          const res = await this.api.optionOtcTradeCfg.buy(params);
          if (res.code === 200) {
            this.$message.success('买入操作成功');
            this.buyModal.visible = false;
          } else {
            this.$message.error(res.info || "买入操作失败");
          }
        } catch (error) {
          console.error("买入操作失败:", error);
          this.$message.error("买入操作失败");
        } finally {
          this.buyModal.loading = false;
        }
      });
    },

    // 赎回操作
    showSellModal(record) {
      this.sellModal.currentRecord = record;
      this.sellModal.visible = true;

      this.$nextTick(() => {
        this.sellFormData = {
          settleDate: null,
          sellAmount: null,
          remark: ""
        };
        this.$refs.sellFormRef && this.$refs.sellFormRef.resetFields();
      });
    },

    // 提交赎回操作
    async handleSellSubmit() {
      this.$refs.sellFormRef.validate(async (valid) => {
        if (!valid) {
          this.$message.error('请填写完整信息');
          return;
        }

        this.sellModal.loading = true;
        try {
          const params = {
            id: this.sellModal.currentRecord.id,
            settleDate: this.sellFormData.settleDate,
            sellAmount: this.sellFormData.sellAmount,
            remark: this.sellFormData.remark
          };

          const res = await this.api.optionOtcTradeCfg.sell(params);
          if (res.code === 200) {
            this.$message.success('赎回操作成功');
            this.sellModal.visible = false;
          } else {
            this.$message.error(res.info || "赎回操作失败");
          }
        } catch (error) {
          console.error("赎回操作失败:", error);
          this.$message.error("赎回操作失败");
        } finally {
          this.sellModal.loading = false;
        }
      });
    },

    // 删除
    handleDelete(record) {
      // 只有审批中或驳回状态可以删除
      // if (!['00', '02'].includes(record.approveStatus)) {
      //   this.$message.warning('只有审批中或驳回状态的记录可以删除');
      //   return;
      // }

      this.currentRecord = record;
      this.deleteModalVisible = true;
    },

    // 确认删除
    async handleDeleteConfirm() {
      try {
        const res = await this.api.optionOtcTradeCfg.delete({id: this.currentRecord.id});
        if (res.code === 200) {
          this.$message.success('删除成功');
          this.fetchData();
        } else {
          this.$message.error(res.info);
        }
      } catch (error) {
        console.error('删除失败:', error);
        this.$message.error('删除失败');
      } finally {
        this.deleteModalVisible = false;
        this.currentRecord = null;
      }
    },

    // 显示审批弹窗
    showApproveModal(record) {
      // 只有审批中状态可以审批
      if (record.approveStatus !== '00') {
        this.$message.warning('只有审批中状态的记录可以审批');
        return;
      }

      this.approveModal.currentRecord = record;
      this.approveModal.visible = true;

      this.$nextTick(() => {
        this.approveFormData = {
          approveStatus: "01",
          approveRemark: ""
        };
        this.$refs.approveFormRef && this.$refs.approveFormRef.resetFields();
      });
    },

    // 处理审批提交
    async handleApproveSubmit() {
      this.$refs.approveFormRef.validate(async (valid) => {
        if (!valid) {
          this.$message.error('请填写完整信息');
          return;
        }

        // 如果审批驳回，必须填写原因
        if (this.approveFormData.approveStatus === '02' && !this.approveFormData.approveRemark.trim()) {
          this.$message.error('请填写驳回原因');
          return;
        }

        this.approveModal.loading = true;
        try {
          const params = {
            id: this.approveModal.currentRecord.id,
            approveStatus: this.approveFormData.approveStatus,
            approveRemark: this.approveFormData.approveRemark
          };

          const res = await this.api.optionOtcTradeCfg.approve(params);
          if (res.code === 200) {
            this.$message.success('审批操作成功');
            this.approveModal.visible = false;
            this.fetchData();
          } else {
            this.$message.error(res.info || "审批操作失败");
          }
        } catch (error) {
          console.error("审批操作失败:", error);
          this.$message.error("审批操作失败");
        } finally {
          this.approveModal.loading = false;
        }
      });
    },

    // 弹窗确认
    async handleModalOk() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;

        this.modalLoading = true;
        try {
          let res;
          if (this.formData.id) {
            this.modalLoading = false;
            this.$message.error("修改暂不开放");
          } else {
            res = await this.api.optionOtcTradeCfg.register(this.formData);
          }

          if (res.code === 200) {
            this.$message.success(this.formData.id ? '修改成功' : '新增成功');
            this.modalVisible = false;
            this.fetchData();
          } else {
            this.$message.error(res.info);
          }
        } catch (error) {
          console.error('操作失败:', error);
          this.$message.error('操作失败');
        } finally {
          this.modalLoading = false;
        }
      });
    },

    // 弹窗取消
    handleModalCancel() {
      this.modalVisible = false;
      this.$refs.formRef.clearValidate();
    },
    // 禁用未来日期
    disabledFutureDate(current) {
      return current && current > moment().endOf('day');
    },

    // 格式化日期时间
    formatDateTime(dateTime) {
      if (!dateTime) return '';
      return new Date(dateTime).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).replace(/\//g, '-');
    },

    // 显示交易记录弹窗
    showTradeRecordModal(record) {
      this.tradeRecordModal.currentRecord = record;
      this.tradeRecordModal.visible = true;
      this.tradeRecordPagination.pageNo = 1;
      this.tradeRecordSearchForm = {
        bizType: undefined,
        status: undefined,
        dateRange: []
      };
      this.fetchTradeRecordData();
    },

    // 交易记录查询条件变更
    handleTradeRecordSearch() {
      this.tradeRecordPagination.pageNo = 1;
      this.fetchTradeRecordData();
    },

    // 获取交易记录数据
    async fetchTradeRecordData() {
      if (!this.tradeRecordModal.currentRecord) return;
      this.tradeRecordLoading = true;
      try {
        const params = {
          pageNo: this.tradeRecordPagination.pageNo,
          pageSize: this.tradeRecordPagination.pageSize,
          configId: this.tradeRecordModal.currentRecord.id,
          bizType: this.tradeRecordSearchForm.bizType || undefined,
          status: this.tradeRecordSearchForm.status || undefined,
          tradeDateStart: this.tradeRecordSearchForm.dateRange?.[0] || undefined,
          tradeDateEnd: this.tradeRecordSearchForm.dateRange?.[1] || undefined
        };
        const res = await this.api.optionOtcTradeCfg.tradeRecordPage(params);
        if (res.code === 200) {
          this.tradeRecordTableData = res.data.records;
          this.tradeRecordTotal = res.data.total;
        } else {
          this.$message.error(res.info);
        }
      } catch (error) {
        console.error('获取交易记录失败:', error);
        this.$message.error('获取交易记录失败');
      } finally {
        this.tradeRecordLoading = false;
      }
    },

    // 显示交易记录详情
    async showTradeRecordDetail(record) {
      try {
        const res = await this.api.optionOtcTradeCfg.tradeRecordDetail({id: record.id});
        if (res.code === 200) {
          this.tradeRecordDetailData = res.data;
          this.tradeRecordDetailVisible = true;
        } else {
          this.$message.error(res.info);
        }
      } catch (error) {
        console.error('获取交易记录详情失败:', error);
        this.$message.error('获取交易记录详情失败');
      }
    }
  }
};
</script>

<style lang="less" scoped>
.selected-box {
  display: flex;
  flex-wrap: wrap;

  /deep/ .selected-box-item {
    margin-right: 20px;
    display: flex;
    justify-content: space-between;
    width: 280px;
    margin-bottom: 20px;
    align-items: center;

    .left-item {
      margin-right: 15px;
      min-width: 80px;
      text-align: right;
    }

    .ant-input,
    .ant-select {
      width: 200px;
    }
  }
}

.table-box {
  margin-top: 20px;

  .table-box-handle {
    margin-bottom: 20px;
  }
}

.trade-record-search {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
</style>
